/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class TemplateDependency {
    getFixupPrototypeFunction() { return TemplateDependency.fixupPrototype; }

    static newInstance(model: Partial<TemplateDependency>): TemplateDependency {
        let obj = Object.assign(new TemplateDependency(), model);
        TemplateDependency.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<TemplateDependency>): TemplateDependency {
        if (!model) return null;
        return TemplateDependency.newInstance(<TemplateDependency> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: TemplateDependency) {
        if (!obj) return;

        models.TemplateDependency.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: TemplateDependency): boolean {
        Object.setPrototypeOf(obj, TemplateDependency.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.content_files) {
            models.TemplateContentFiles.fixupPrototype(this.content_files);
        }
    }

    /**
     * Referenced module's name, e.g. 'networking'
     */
    name: string;

    /**
     * Dependency type
     */
    type: models.TemplateDependencyType;

    /**
     * The referenced module's own files (same shape as content_files)
     */
    content_files: models.TemplateContentFiles;

}
